module.exports = __webpack_public_path__ + "static/media/logo_demetra_white.997864bd.png";